const translations = {
  en: {
    depositUsing: 'Deposit using',
    clickToConfirmZelle: 'Click here to confirm a&nbsp;&nbsp;<b>zelle deposit</b>',
    pendingZelle: 'Pending Zelle confirmations:',
    tnxId: 'Tnx ID',
    code: 'Code',
    amount: 'Amount',
    date: 'date',
    complete: 'Complete',
    secureId: 'SecureID:',
    secureIdPlaceholder: 'SecureID',
    account: 'Account:',
    accountPlaceholder: 'Account',
    currency: 'Currency',
    amountPlaceholder: 'Enter amount here',
    depositLimits: 'Deposit Limits: Minimum',
    maximum: 'Maximum',
    noLimit: 'No Limit',
    back: 'BACK',
    getNewInstructions: 'GET NEW INSTRUCTIONS',
    warning: 'Warning',
    error: 'Error',
    amountRequired: 'Amount required',
    depositPending: 'Deposit Pending',
    depositRejected: 'eWallet Deposit Rejected',
    depositCompleted: 'eWallet Deposit Completed',
    errorWithEwalletDeposit: 'Error with eWallet Deposit',
    errorWithDeposit: 'Error with Deposit',
    errorMakingDeposit: 'Error making deposit',
  },
  es: {
    depositUsing: 'Depositar usando',
    clickToConfirmZelle: 'Haga clic aquí para confirmar un&nbsp;&nbsp;<b>depósito zelle</b>',
    pendingZelle: 'Confirmaciones Zelle pendientes:',
    tnxId: 'ID Trx',
    code: 'Código',
    amount: 'Monto',
    date: 'fecha',
    complete: 'Completar',
    secureId: 'SecureID:',
    secureIdPlaceholder: 'SecureID',
    account: 'Cuenta:',
    accountPlaceholder: 'Cuenta',
    currency: 'Moneda',
    amountPlaceholder: 'Ingrese el monto aquí',
    depositLimits: 'Límites de depósito: Mínimo',
    maximum: 'Máximo',
    noLimit: 'Sin Límite',
    back: 'ATRÁS',
    getNewInstructions: 'OBTENER NUEVAS INSTRUCCIONES',
    warning: 'Advertencia',
    error: 'Error',
    amountRequired: 'Monto requerido',
    depositPending: 'Depósito Pendiente',
    depositRejected: 'Depósito eWallet Rechazado',
    depositCompleted: 'Depósito eWallet Completado',
    errorWithEwalletDeposit: 'Error con el Depósito eWallet',
    errorWithDeposit: 'Error con el Depósito',
    errorMakingDeposit: 'Error al realizar el depósito',
  },
  pt: {
    depositUsing: 'Depositar usando',
    clickToConfirmZelle: 'Clique aqui para confirmar um&nbsp;&nbsp;<b>depósito zelle</b>',
    pendingZelle: 'Confirmações Zelle pendentes:',
    tnxId: 'ID Trx',
    code: 'Código',
    amount: 'Valor',
    date: 'data',
    complete: 'Completar',
    secureId: 'SecureID:',
    secureIdPlaceholder: 'SecureID',
    account: 'Conta:',
    accountPlaceholder: 'Conta',
    currency: 'Moeda',
    amountPlaceholder: 'Insira o valor aqui',
    depositLimits: 'Limites de depósito: Mínimo',
    maximum: 'Máximo',
    noLimit: 'Sem Limite',
    back: 'VOLTAR',
    getNewInstructions: 'OBTER NOVAS INSTRUÇÕES',
    warning: 'Aviso',
    error: 'Erro',
    amountRequired: 'Valor obrigatório',
    depositPending: 'Depósito Pendente',
    depositRejected: 'Depósito eWallet Rejeitado',
    depositCompleted: 'Depósito eWallet Concluído',
    errorWithEwalletDeposit: 'Erro com Depósito eWallet',
    errorWithDeposit: 'Erro com Depósito',
    errorMakingDeposit: 'Erro ao realizar o depósito',
  },
}

export default translations
